import Vue from 'vue'
import './hint-text.scss'

import withRender from './hint-text.html'

const TYPES = ['alert', 'error', 'info']

export default withRender(Vue.extend({
  props: {
    type: {
      type: String,
      default: 'info',
      validator: v => TYPES.indexOf(v) > -1
    },
    text: { type: String }
  },
  computed: {
    iconName() {
      return this.type === 'alert' ? 'question' : this.type
    },
    hasValidType() {
      return TYPES.indexOf(this.type) > -1
    }
  }
}))
